import { render } from "./HelloWorld.vue?vue&type=template&id=2cbd3ff6&bindings={\"address\":\"props\",\"balance\":\"props\",\"connectWallet\":\"options\"}"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"
script.render = render

export default script